import React, { useState } from "react";
import "./PowderSlider.css";
import tomato from "./tomato.png";
import onion from "./onion.png";
import turmeric from "./turmeric.png";
import cocoa from "./cocoa.png";
import banana from "./banana.png";

const PowderSlider = () => {
  const slides = [
    {
      title: "Banana Powder",
      bgColor: "#fff7c2",
      image: banana,
      points: [
        {
          heading: "Baby Foods & Health Mixes",
          text: "Used as a nutritious ingredient in infant food and health mixes."
        },
        {
          heading: "Bakery & Confectionery",
          text: "Adds natural sweetness and flavor to cakes, muffins, and biscuits."
        },
        {
          heading: "Smoothies & Shakes",
          text: "Used as a natural flavoring and thickener in drinks."
        },
        {
          heading: "Snack Manufacturing",
          text: "Used in banana chips seasoning and fruit-based snacks."
        },
        {
          heading: "Cosmetics & Face Packs",
          text: "Used for skin-friendly, natural cosmetic formulations."
        },
        {
          heading: "Animal Feed",
          text: "Added in animal nutrition as a natural carbohydrate source."
        }
      ]
    },
    {
      title: "Tomato Powder",
      bgColor: "#ffb9a0",
      image: tomato,
      points: [
        {
          heading: "Ingredient in Instant Mixes",
          text: "Used in noodles, soups, pasta mixes, and gravies."
        },
        {
          heading: "Snack & Seasoning Manufacturing",
          text: "Added to spice blends for chips, namkeens, popcorn, and more."
        },
        {
          heading: "Bakery & Savory Breads",
          text: "Tomato powder can add flavor and natural red-orange color to breads and biscuits."
        },
        {
          heading: "Dry Rubs & Marinades",
          text: "Ideal for dry rubs and marinating powders."
        },
        {
          heading: "Sauce Concentrate Replacement",
          text: "More shelf-stable and concentrated than fresh tomatoes or paste."
        },
        {
          heading: "Pet Food & Animal Nutrition",
          text: "Sometimes used in pet food formulas for flavor and color enhancement."
        }
      ]
    },
    {
      title: "Onion Powder",
      bgColor: "#f9c9cb",
      image: onion,
      points: [
        {
          heading: "Cooking & Seasoning",
          text: "Flavors various recipes such as soups, sauces, stews, and curries."
        },
        {
          heading: "Snack & Processed Foods",
          text: "Commonly added in chips, bhujia, and seasoning for fast food."
        },
        {
          heading: "Export/Industrial Use",
          text: "Used in instant mixes, spice powders, and seasoning exports."
        },
        {
          heading: "Meat & Meat Substitute Products",
          text: "Vegan, meat-replacement foods like burgers and cutlets use onion powder."
        },
        {
          heading: "Baking & Savory Breads",
          text: "Used in onion bagels, savory muffins, and biscuits."
        },
        {
          heading: "Functional Foods & Supplements",
          text: "May be used in herbal blends or nutraceuticals for antioxidant properties."
        }
      ]
    },
    {
      title: "Turmeric Powder",
      bgColor: "#ffe88b",
      image: turmeric,
      points: [
        {
          heading: "Culinary Applications",
          text: "A staple in Indian cooking, adds color and earthy flavor."
        },
        {
          heading: "Health Supplements",
          text: "Used in capsules and health drinks for its anti-inflammatory benefits."
        },
        {
          heading: "Cosmetic Industry",
          text: "Used in creams and masks for natural skin glow."
        },
        {
          heading: "Food Processing",
          text: "Used as a natural colorant in snacks, pickles, and dairy."
        },
        {
          heading: "Pharmaceutical Use",
          text: "Curcumin extract used for therapeutic properties."
        },
        {
          heading: "Pet and Livestock Feed",
          text: "Added for natural health benefits and color enrichment."
        }
      ]
    },
    {
      title: "Cocoa Powder",
      bgColor: "#d9b9a9",
      image: cocoa,
      points: [
        {
          heading: "Bakery & Confectionery",
          text: "Used in cakes, brownies, and pastries for rich chocolate flavor."
        },
        {
          heading: "Beverages",
          text: "Key ingredient in hot chocolate, milkshakes, and protein powders."
        },
        {
          heading: "Ice Cream & Desserts",
          text: "Adds flavor and color to ice creams and puddings."
        },
        {
          heading: "Nutritional Supplements",
          text: "Used in health and protein blends for flavor enhancement."
        },
        {
          heading: "Cosmetic Use",
          text: "Used in scrubs and face masks for antioxidants."
        },
        {
          heading: "Snack Industry",
          text: "Flavoring agent for chocolate-coated nuts, wafers, and cereals."
        }
      ]
    }
  ];

  const [index, setIndex] = useState(0);

  return (
    <div
      className="powder-slide"
      style={{ backgroundColor: slides[index].bgColor }}
    >
      <div className="powder-content">
        <div className="powder-image">
          <img src={slides[index].image} alt={slides[index].title} />
        </div>

        <div className="powder-text">
          <h2>{slides[index].title}</h2>
          <div className="points">
            {slides[index].points.map((p, i) => (
              <div key={i} className="point">
                <h4>{p.heading}</h4>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="powder-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default PowderSlider;
